import { Flex, Skeleton } from "@mantine/core";

function NotificationLoading(props: { id: number }) {
  return (
    <Flex gap={16} py={8} my={8} key={`notif-skeleton-${props.id}`}>
      <Skeleton height={38} width={38} circle />

      <Flex direction="column" className="w-full">
        <Skeleton height={14} radius="xl" width="80%" mb="4" />
        <Skeleton height={14} radius="xl" width="80%" />
      </Flex>
    </Flex>
  );
}

export default NotificationLoading;
